import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AppMsalAuthService } from '../../auth/authentication-service/app-msal-auth.service';
import { UserService } from '../../auth/user-service/user.service';
import { catchError, map, of, tap } from 'rxjs';
import { LoggerService } from '../../services/logger/logger-service/logger.service';

export const authorisedGuard: CanActivateFn = (route, state) => {
    const logger = inject(LoggerService);
    const authService = inject(AppMsalAuthService);
    const userService = inject(UserService);
    const router = inject(Router);

    // Navigation helper
    const redirectToUnauthorised = () => {
        const route = 'unauthorised';
        router.navigate([route]);
    };

    // User is unauthenticated
    if (!authService.isLoggedIn()) {
        return false; // login redirect handled by MsalGuard
    }

    // User is authenticated
    return userService.getUser().pipe(
        map(user => user !== null),
        tap(authorised => {
            logger.info('User authorised', authorised);
            if (!authorised) {
                redirectToUnauthorised();
            }
        }),
        catchError(error => {
            logger.error(error);
            redirectToUnauthorised();
            return of(false);
        }),
    );
};
